import React from "react";
import styled from "styled-components";
import { colors } from "core/stylesheet";

const Input = styled.input.attrs({
  className: "br1 pointer"
})`
  appearance: none;
  outline: none;
  width: 18px;
  height: 18px;
  top: 4px;
  border: 1px solid #aaa;
  margin-right: 5px;
  position: relative;
  flex-shrink: 0;
  &:checked:before {
    content: "✔";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.brand};
    font-family: "CircularStd-Book";
    direction: ltr;
    -webkit-font-feature-settings: "liga";
    -webkit-font-smoothing: antialiased;
  }
`;
const Wrap = styled.div`
  font-family: "CircularStd-Book", sans-serif;
`;
export default ({
  name,
  checked,
  value,
  onChange,
  onBlur,
  children,
  disabled
}) => (
  <label className="flex pointer pa3">
    <Input
      name={name}
      checked={checked}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      type="checkbox"
      disabled={disabled}
    />
    {children && <Wrap className="ml1">{children}</Wrap>}
  </label>
);



// WEBPACK FOOTER //
// ./src/components/generic/form/native/Checkbox/index.js